import { render, staticRenderFns } from "./OnlineSign.vue?vue&type=template&id=580b64dc&scoped=true&"
import script from "./OnlineSign.vue?vue&type=script&lang=js&"
export * from "./OnlineSign.vue?vue&type=script&lang=js&"
import style0 from "./OnlineSign.vue?vue&type=style&index=0&id=580b64dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580b64dc",
  null
  
)

export default component.exports